/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Project_Type_TeamInputs */



/**
* | output |
* | --- |
* | "Team" |
*
* @param {Options_General_Project_Type_TeamInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_project_type_team = /** @type {((inputs?: Options_General_Project_Type_TeamInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Project_Type_TeamInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Team")
	if (locale === "it") return /** @type {LocalizedString} */ ("Squadra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Команда")
	if (locale === "es") return /** @type {LocalizedString} */ ("Equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("团队")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Equipe")
	return /** @type {LocalizedString} */ ("Team")
});